<template>
    <button v-for="item in rewards" :key="item"
            class="transition ease-in-out delay-150 hover:scale-105 col-span-2 md:col-span-1 shadow-2xl w-full"
    >
        <div class="flex justify-center mx-auto h-full w-full bg-racing-stars-dirty-yellow rounded-md border transition
         duration-100 ease-in-out border-racing-stars-yellow hover:bg-[#544f2b] active:bg-[#635d30] animate-flow">
            <div class="p-4 ">
              <span class="w-full flex flex-col font-bold text-white mx-auto text-center mt-2">
                <p class="text-md sm:text-lg rounded-lg h-10 sm:h-fit mb-0 sm:mb-3 leading-tight sm:leading-tight">
                  {{ item.named }}
                </p>
              </span>
                <div>
                    <img class="w-fit mx-auto px-auto mb-3 img-width" :src="`storage/${item.image}`"
                    />
                </div>
                <p class="text-md sm:text-lg  mx-auto text-center h-fit sm:h-fit mb-0 sm:mb-1 leading-tight text-white rounded-full font-semibold backdrop-blur-md">
                    Quantity : {{ item.quantity }}
                </p>
            </div>
        </div>
    </button>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
    setup() {
        const rewards = ref([]);

        const fetchRewards = () => {
            axios.get(route('api.reward.show'))
                .then((response) => {
                    if (response.data.success) {
                        rewards.value = response.data.rewards;
                        console.log(response.data.rewards);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        };

        onMounted(() => {
            fetchRewards();
        });

        return {
            rewards,
        };
    },
};
</script>

<style scoped>
.bg-store-product{
    background-color: #6e647a !important;
}
.img-width{
    width: 100%;
    height: 119px;
    object-fit: cover;
    border-radius: 9px;
}
</style>
